module.exports = __webpack_public_path__ + "static/media/gallery_04.77dd3771.png";